export const UPLOAD_FILE_REQUEST = "UPLOAD_FILE_REQUEST";
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAILURE = "UPLOAD_FILE_FAILURE";

export const FETCH_FILES_REQUEST = "FETCH_FILES_REQUEST";
export const FETCH_FILES_SUCCESS = "FETCH_FILES_SUCCESS";
export const FETCH_FILES_FAILURE = "FETCH_FILES_FAILURE";

export const BULK_UPLOAD_FILE_REQUEST = "BULK_UPLOAD_FILE_REQUEST";
export const BULK_UPLOAD_FILE_SUCCESS = "BULK_UPLOAD_FILE_SUCCESS";
export const BULK_UPLOAD_FILE_FAILURE = "BULK_UPLOAD_FILE_FAILURE";

export const DOWNLOAD_FILE_REQUEST = "DOWNLOAD_FILE_REQUEST";
export const DOWNLOAD_FILE_SUCCESS = "DOWNLOAD_FILE_SUCCESS";
export const DOWNLOAD_FILE_FAILURE = "DOWNLOAD_FILE_FAILURE";

export const PREVIEW_FILE_REQUEST = "PREVIEW_FILE_REQUEST";
export const PREVIEW_FILE_SUCCESS = "PREVIEW_FILE_SUCCESS";
export const PREVIEW_FILE_FAILURE = "PREVIEW_FILE_FAILURE";

export const DELETE_FILE_REQUEST = "DELETE_FILE_REQUEST";
export const DELETE_FILE_SUCCESS = "DELETE_FILE_SUCCESS";
export const DELETE_FILE_FAILURE = "DELETE_FILE_FAILURE";

export const FETCH_DOCUMENT_TYPES_REQUEST = "FETCH_DOCUMENT_TYPES_REQUEST";
export const FETCH_DOCUMENT_TYPES_SUCCESS = "FETCH_DOCUMENT_TYPES_SUCCESS";
export const FETCH_DOCUMENT_TYPES_FAILURE = "FETCH_DOCUMENT_TYPES_FAILURE";
